import { useState } from 'react';
import { Modal } from '../../../../../components/ui/Modal';
import { Input } from '../../../../../components/ui/Input';
import { Button } from '../../../../../components/ui/Button';
import { useAddCitationProbe } from '../../../../../hooks/useMeasurement';

export function AddProbeModal({ onClose }: { onClose: () => void }) {
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('rfp-software');
  const addProbe = useAddCitationProbe();

  const handleSubmit = () => {
    if (!query.trim()) return;
    addProbe.mutate({ query: query.trim(), category }, { onSuccess: onClose });
  };

  return (
    <Modal isOpen onClose={onClose} title="Add Prompt" size="md">
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-text-primary mb-1">Query</label>
          <Input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Best RFP response software for enterprise"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-text-primary mb-1">Category</label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="w-full rounded-md border border-border bg-surface-primary px-3 py-2 text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-text-primary"
          >
            <option value="rfp-software">RFP / Proposal Software</option>
            <option value="bid-management">Bid & Tender Management</option>
            <option value="ai-rfp">AI & Automation</option>
            <option value="alternatives">Competitor Alternatives</option>
            <option value="industry">Industry & Use Cases</option>
          </select>
        </div>
        <div className="flex justify-end gap-3 pt-2">
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button onClick={handleSubmit} isLoading={addProbe.isPending}>Add Prompt</Button>
        </div>
      </div>
    </Modal>
  );
}
